import { EMPTY_QUOTA, isOutOfQuota } from '../../domain/quota';

import { useEmailsQuotaQuery } from './useEmailsQuotaQuery';

export const useIsOutOfEmailsQuota = () => {
  const emailsQuota = useEmailsQuotaQuery().data;

  return isOutOfQuota(emailsQuota ?? EMPTY_QUOTA);
};
